var map = {
	"./Rectangle-24-2.jpg": 3745,
	"./Rectangle-25-2.jpg": 472,
	"./Rectangle-26-2.jpg": 3007,
	"./Rectangle-27-1.jpg": 6377,
	"./Rectangle-28-1.jpg": 9722,
	"./Rectangle-29.jpg": 625
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4247;